import styled from 'styled-components';
import {
    TabList
} from '@mlb/react-patterns/v4/components/Tabs/tabs';
import { StyledButton, Label as ButtonLabel } from '@mlb/react-patterns/v4/components/Button/button.style'

export const TabsWrapper = styled.div`

    ${StyledButton} {
        font-family: var(--gameday-primary-font);
        margin-right: 24px;
        margin-top: 16px;
        margin-bottom: 16px;
        padding:0px;
        font-weight: 700;
        font-size: 20px;
        line-height: 20px;
        height: 20px;

        &[data-selected=true] {
            font-weight: 800;
        }
    }
    ${StyledButton},
    ${StyledButton}:hover {
        border-bottom: none;
    }
    ${StyledButton}:not([data-selected=true]):not(:hover) {
        ${ButtonLabel} {
            color: var(--gameday-tab-button-inactive-color);
        }
    }

`;

export const TabListOverride = styled(TabList)`
`;
